import { isoToDay, periodRange } from "./dayMath";

/** The first and last day of a project as the server describes it, or null while they are not known. */
export function projectSpan(project) {
  if (!project?.startDate || !project?.endDate) return null;
  return { startDay: isoToDay(project.startDate), endDay: isoToDay(project.endDate) };
}

/**
 * The days the planner summarises, `{ startDay, endDay }`: the hours of the rows, the number of tasks in them and the
 * figures of Resource Insights all refer to it.
 *
 * @param summaryPeriod  the period chosen above the left panel (see `periodRange`)
 * @param customPeriod  the days the user picked, for `custom`
 * @param project  the project the planner is limited to, as the server describes it, for `overall`
 */
export function summaryRangeOf({ summaryPeriod, customPeriod, project, today }) {
  return periodRange(summaryPeriod, today, { custom: customPeriod, project: summaryPeriod === "overall" ? projectSpan(project) : null });
}
